/**
 * The skeleton section numbers of the document last scaffolded or hydrated
 * into Word. Set by wordWriter; read by ``splitDraftBySections`` so a module
 * draft's heading for ANOTHER module's section is recognised as foreign
 * rather than inlined under this module (§8's text landing under §7).
 *
 * Empty until a scaffold/hydrate runs — callers then behave as before.
 */
let _numbers: ReadonlySet<string> = new Set();

export function setKnownSkeletonSections(numbers: Iterable<string>): void {
  _numbers = new Set(numbers);
}

export function knownSkeletonSections(): ReadonlySet<string> {
  return _numbers;
}
